export const PAGE_SERVICE_UNAVAILABLE_HREF = '/ca/service-unavailable';
export const PAGE_NOT_FOUND_HREF = '/ca/not-found';
export const PAGE_ERROR_HREF = '/ca/error-page';

export const redirectToErrorPage = (targetUrl: string) => {
  const { href } = window.location;
  if (
    !href.endsWith(PAGE_NOT_FOUND_HREF) &&
    !href.endsWith(PAGE_ERROR_HREF) &&
    !href.endsWith(PAGE_SERVICE_UNAVAILABLE_HREF)
  ) {
    window.location.href = targetUrl;
  }
};
